import React from "react";
import { useQuery } from "@apollo/client";
import { Row, Col } from "react-bootstrap";
import { GET_ACTIVE_SYSTEMS } from "../../../queries/archiveQrys/secureQrys/statewideReportQry";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";
import ChartLegend from "../../reuseableComponents/graphsAndCharts/ChartLegend";
import DeqPieChart from "../../reuseableComponents/graphsAndCharts/DeqPieChart";

const colors = ["#0080b7", "#00afd8", "#add361"];

const WtrSysByRating = () => {
  const { loading, error, data } = useQuery(GET_ACTIVE_SYSTEMS);
  if (loading || error) {
    return (
      <>
        <Row>
          <Col>
            <h3>Water Systems By Ratings</h3>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorHandler error={error} /> : ""}</Col>
        </Row>
      </>
    );
  }
  return (
    <React.Fragment>
      <Row>
        <Col>
          <h3>Water Systems By Ratings</h3>
        </Col>
      </Row>
      <Row>
        <Col cypressid='wtrSysByRatingLegend'>
          <ChartLegend data={data.getActiveWaterSystemRatingsCount} colorArray={colors} />
        </Col>
      </Row>
      <Row>
        <Col cypressid='wtrSysByRatingChart'>
          <DeqPieChart data={data.getActiveWaterSystemRatingsCount} colorArray={colors} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default WtrSysByRating;
